module.exports = __webpack_public_path__ + "static/bubble-cat-69fbf190db03daa6c20fe435f4aff74f.png";